export const REVIEWER_DETAILS_KEY = 'reviewer_details';
